module.exports = __webpack_public_path__ + "img/zphd_ljcj_s2.1821dfba.png";